<script>
  import { apiFetch } from "../lib/api.js";
  import { links, navigate } from "svelte-routing"
  import { onDestroy, onMount } from "svelte"
  import { globalHistory } from "svelte-routing/src/history"
  import { BASE_URL } from "../stores/BASE_URL"
  import { user } from "../stores/user"

  let pathname = window.location.pathname
  let unsub

  onMount(() => {
    unsub = globalHistory.listen(({ location }) => {
      pathname = location.pathname
    })
  })

  onDestroy(() => {
    unsub()
  })

  const logout = async () => {
    try {
      await apiFetch(new URL("session.php?action=logout", BASE_URL).href, { method: "POST" })
    } finally {
      user.setUser(null)
      navigate("/", { replace: true })
    }
  }
</script>

<nav class="navbar navbar-expand-xl navbar-light bg-white shadow-sm sticky-top">
  <div class="container-fluid">
    <div class="d-flex flex-row py-1 text-secondary">
      <div class="text-end border-secondary pe-2 border-end">
        <p
          class="p-0 m-0 lh-1 fs-5 navbar-brand"
          style="font-family: 'Raleway', sans-serif;"
        >
          DomaDesk
        </p>
        <p
          class="p-0 m-0 lh-1 fs-5 navbar-brand"
          style="font-family: 'Raleway', sans-serif;"
        >
          IAM
        </p>
      </div>
      <div class="d-flex align-items-center">
        <p
          class="m-0 ps-2 navbar-brand"
          style="font-family: 'Raleway', sans-serif; font-size: 11px;"
        >
          Identity & Access Management
        </p>
      </div>
    </div>

    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarScroll"
      aria-controls="navbarScroll"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarScroll">
      <ul class="navbar-nav ms-auto my-2 my-lg-0 navbar-nav-scroll" use:links>
        <li class="nav-item">
          <a
            class="nav-link"
            class:active={pathname.includes("/clientes")}
            href="/clientes">Clientes</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            class:active={pathname.includes("/usuarios")}
            href="/usuarios">Usuarios</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            class:active={pathname.includes("/modificaciones_futuras")}
            href="/modificaciones_futuras">Modificaciones futuras</a
          >
        </li>
        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            class:active={pathname.includes("/reporte_")}
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Reportes
          </a>
          <ul class="dropdown-menu">
            <li>
              <a
                class="nav-link"
                class:active={pathname.includes("/reporte_consultas")}
                href="/reporte_consultas">Reporte consultas</a
              >
            </li>
            <li>
              <a
                class="nav-link"
                class:active={pathname.includes("/reporte_diario")}
                href="/reporte_diario">Reporte diario</a
              >
            </li>
          </ul>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            class:active={pathname.includes("/acciones")}
            href="/acciones">Acciones</a
          >
        </li>
        {#if $user.rol == "administrador" || $user.rol == "operaciones"}
          <li class="nav-item">
            <a
              class="nav-link"
              class:active={pathname.includes("/notificaciones")}
              href="/notificaciones">Notificaciones</a
            >
          </li>
        {/if}
        <li class="nav-item">
          <a
            class="nav-link"
            class:active={pathname.includes("/ips_bloqueadas")}
            href="/ips_bloqueadas">IPs bloqueadas</a
          >
        </li>
      </ul>
      <div class="dropdown">
        <div class="btn-group ms-2">
          <button
            type="button"
            class="btn btn-sm dropdown-toggle text-secondary"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="bi bi-person-fill" />
            {$user.nombres}
          </button>
          <ul class="dropdown-menu dropdown-menu-end text-end" use:links>
            <li>
              <a class="dropdown-item disabled" href="/configuracion">
                <span class="small">Configuración</span>
                <i class="bi bi-gear-fill" />
              </a>
            </li>
            <li>
              <button
                class="dropdown-item text-danger"
                type="button"
                on:click={logout}
              >
                <span class="small">Cerrar sesión</span>
                <i class="bi bi-box-arrow-right" />
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</nav>
